module.exports = __webpack_public_path__ + "assets/65c2725c4a44a54750a4aa36e88d50bb.png";